module.exports = __webpack_public_path__ + "static/media/security.92c81737.png";